import { schema } from 'normalizr';

export type DeviceTypeDisplayName = {
  displayName: string;
  deviceType: string;
};

export const toDeviceTypeDisplayNamesSchema = (options: schema.EntityOptions = {}) =>
  new schema.Entity('deviceTypeDisplayNames', {}, options);
